import { Cell as AriaCell, type CellProps as AriaCellProps } from "react-aria-components";
import { tv } from "tailwind-variants";

import { cn } from "@/lib/helpers/cn";

export function Cell2({ children, className, ...props }: AriaCellProps) {
  const { cell } = styles();

  return (
    <AriaCell className={cn(cell(), className)} {...props}>
      {children}
    </AriaCell>
  );
}

const styles = tv({
  slots: {
    cell: cn(
      "tw:px-4 tw:py-5",
      "tw:first:pl-6 tw:last:pr-6 tw:last:text-end!",
      "tw:text-md tw:text-text-primary",
      "tw:border-b tw:border-b-stroke-tertiary",
      "tw:group-last/row:border-b-0",
    ),
  },
});
